export default function FeedGridController(module) {
    /**
     * @ngdoc controller
     * @name FeedGridController
     * @description
     * Collects information used to filter the feed and sets up configuration for modal carousel.
     * */
    angular.module(module || 'app')
        .controller('FeedGridController', FeedGridController);

    FeedGridController.$inject = ['$scope', '$attrs', '$window', '$timeout', '$q', 'feedResource'];
    function FeedGridController($scope, $attrs, $window, $timeout, $q, feedResource) {
        var vm = this;
        vm.$onInit = function () {
            vm.params = JSON.parse($attrs.parameters);
            vm.defaultState = JSON.parse($attrs.defaultState);
            vm.initCategories = [];
            vm._filtersData = JSON.parse($attrs.filters);
            vm.categories = [];
            vm._filtersData.forEach(filter => {
                vm.categories.push([]);
            });
            var hasHistory = $window.history.state;
            if ($attrs.initCategory) {
                vm.categories = JSON.parse($attrs.initCategory);
            }
            else if ($window.history && $attrs.preserveFilters === 'true') {
                $window.addEventListener('beforeunload', event => {
                    var state = angular.copy(vm.params);
                    if (state.categories) {
                        state.categoriesRaw = state.categories.map(item => {
                            return Array.isArray(item.tags) ? item.tags : Object.values(item.tags);
                        });
                    }
                    $window.history.replaceState(state, document.querySelector('title').innerText);
                });
                if (hasHistory) {
                    vm.params = angular.copy($window.history.state);
                    if ($window.history.state.categoriesRaw) {
                        vm.categories = $window.history.state.categoriesRaw;
                        delete vm.params.categoriesRaw;
                    }
                }
            }
            vm.page = vm.params.page;
            vm.searchTerm = vm.params.searchTerm;
            vm.sortType = vm.params.sortType;
            vm.location = vm.params.location;
            vm.filters = [];

            vm._calibrateFilters();
        }
        vm.openModal = function ($event, index, id) {
            $event.preventDefault();
            $scope.$root.lockScroll = true;
            if (vm.carousel) {
                vm.carousel.goToSlide(index, false);
            }
            this.modalOpen = true;
            $scope.$broadcast('playVideo', id + '-' + index);
            $timeout(function () {
                $scope.$broadcast('feedModalOpened', index);
            })
        };

        vm.searchByText = (field) => {
            vm.params = angular.copy(vm.params);
            vm.params[field] = vm[field];
            vm.closeFilters();
        }

        vm.playVideo = function (index) {
            $scope.$broadcast('playVideo', vm._contentTypeAlias + '-' + index);
        }

        vm.pauseVideo = function (previousIndex) {
            $scope.$broadcast('pauseVideo', vm._contentTypeAlias + '-' + previousIndex);
        }

        vm.closeModal = function () {
            this.modalOpen = false;
            $scope.$root.lockScroll = false;
            $scope.$broadcast('closeVideos');
            $scope.$broadcast('feedModalClosed');
        };

        vm.blockClose = function (event) {
            event.stopPropagation();
        };

        vm.registerCarousel = function (carousel) {
            vm.carousel = carousel;
        };

        vm.updateSlides = function (slides, page) {
            if (slides && slides.length) {
                vm._contentTypeAlias = slides[0].contentTypeAlias;
            }
            if (page) {
                vm.page = page;
            }
            vm._resetCheck();
            vm.modalSlides = angular.copy(slides);
        };

        vm.updateHash = function (slide) {
            if (slide) {
                $window.location.hash = slide.urlName;
            }
        };

        vm.syncAnimations = function () {
            if ($window.wow) {
                $timeout(function () {
                    $window.wow.sync();
                });
            }
        };

        vm.updateCategories = () => {
            if (vm._categoriesCalibrated) {
                var categories = [];
                vm.categories.forEach((category, i) => {
                    categories.push({
                        tags: typeof(category) === 'string' ? [category] : angular.copy(category),
                        orLogic: vm.filters[i].orLogic
                    });
                });
                vm.params = angular.copy(vm.params);
                vm.params.categories = categories.length ? categories : null;
                vm.page = 1;
            }
        }

        vm.checkCaps = function () {
            $scope.$broadcast('checkCaps');
        };

        vm._calibrateFilters = () => {
            var calibrationPromises = [];
            vm._filtersData.forEach(filters => {
                calibrationPromises.push(feedResource.calibrateFilters(vm.params.ids, vm.params.pageId, filters.tags, vm.params.allowedContentTypes, vm.params.deepSearch, vm.params.culture, vm.params.searchTerm));
            });
            calibrationPromises.forEach((promise, i) => {
                promise.then(function (result) {
                    var filters = result.data;
                    filters.forEach(filter => {
                        filter.value = filter.key.replaceAll('-', '');
                        filter.label = filter.name;

                    });
                    vm.filters[this] = {
                        tags: filters,
                        orLogic: vm._filtersData[this].orLogic
                    };
                }.bind(i));
            });

            $q.all(calibrationPromises)
                .then(() => {
                    vm._categoriesCalibrated = true;
                    vm._resetCheck();
                });
        }

        vm.updateSort = () => {
            vm.params = angular.copy(vm.params);
            vm.params.sortType = vm.sortType;
            vm._resetCheck();
        };

        vm.openFilters = () => {
            vm.filtersOpen = true;
        };

        vm.closeFilters = () => {
            vm.filtersOpen = false;
        }

        vm.reset = () => {
            var defaultData = JSON.parse(JSON.stringify(vm.defaultState));
            if (vm.params.location) {
                defaultData.location = vm.params.location;
            }
            defaultData.categories = vm.categories.length ? vm.categories : null;
            vm.params.page = vm.page;
            vm.page = defaultData.page;
            vm.searchTerm = defaultData.searchTerm;
            vm.sortType = defaultData.sortType;
            if (vm.filters && vm.filters.length) {
                var categories = []
                vm.filters.forEach((filter, i) => {
                    filter.tags.forEach(tag => {
                        tag.active = false;
                    });
                    categories.push({
                        tags: [],
                        orLogic: filter.orLogic
                    });
                    if (vm.categories[i].length) {
                        vm.categories[i].splice(0, vm.categories[i].length);
                    }
                });
                defaultData.categories = categories;
            }
            vm.params = defaultData;
            vm.resetable = false;
        }

        vm._resetCheck = () => {
            vm.resetable = vm.page > 1 || JSON.stringify(vm.defaultState) !== JSON.stringify(vm.params);
        }

        vm.clearSearchTerm = () => {
            // check every categories, if all blank call reset instead, if not just clear search term and don't reset
            var allBlank = true;
            if (vm.categories.length) {
                vm.categories.forEach((category) => {
                    if (category.length) {
                        allBlank = false;
                        return;
                    }
                })
            }

            if (allBlank) {
                vm.reset();
            } else {
                vm.searchTerm = null;
                vm.searchByText('searchTerm');
                vm.resetable = true;
            }
        }
    }
};